import { z } from 'zod/v4';

const id = z.string().min(1).max(64);

export const TracingLinkQuerySchema = z.object({ tracingOrderId: id });
export type TracingLinkQuery = z.infer<typeof TracingLinkQuerySchema>;

export const TracingLinkParamsSchema = z.object({ id, tracingOrderId: id });
export type TracingLinkParamsType = z.infer<typeof TracingLinkParamsSchema>;

export const LinkTracingRequestInputSchema = z.object({
  tracingOrderId: id,
  direction: z.enum(['ORDER_HUB', 'TRACING']),
  lineMode: z.enum(['MERGE', 'REPLACE']),
  sameLines: z
    .array(z.object({ orderLineId: id, tracingLineId: id }))
    .max(500)
    .optional(),
});
export type LinkTracingRequestInput = z.infer<
  typeof LinkTracingRequestInputSchema
>;

export const ReferenceTracingRequestInputSchema = z.object({
  tracingOrderId: id,
  orderLineIds: z.array(id).min(1).max(500),
});
export type ReferenceTracingRequestInput = z.infer<
  typeof ReferenceTracingRequestInputSchema
>;

const LineSchema = z.object({
  id: z.string(),
  styleId: z.string().nullable(),
  styleName: z.string().nullable(),
  quantity: z.number().nullable(),
  unit: z.string().nullable(),
  secondaryQuantity: z.number().nullable(),
  secondaryUnit: z.string().nullable(),
});

const FieldsSchema = z.object({
  orderNumber: z.string().nullable(),
  status: z.string().nullable(),
  orderDate: z.string().nullable(),
  agreedDeliveryDate: z.string().nullable(),
  deliveryDate: z.string().nullable(),
  tags: z.array(z.string()),
  attachmentTemplateId: z.string().nullable(),
  buyerFacilityProcess: z.string().nullable(),
  supplierFacilityProcess: z.string().nullable(),
});

const GapSchema = z.object({
  orderLineId: z.string().optional(),
  tracingLineId: z.string().optional(),
  reasons: z.array(z.string()),
});

const PairSchema = z.object({
  orderLineId: z.string(),
  tracingLineId: z.string(),
});

export const TracingLinkPreviewSchema = z.object({
  kind: z.enum(['OWNER', 'RECEIVED']),
  tracingOrderId: z.string(),
  primaryId: z.string(),
  request: z.object({ fields: FieldsSchema, lines: z.array(LineSchema) }),
  order: z.object({
    id: z.string(),
    fields: FieldsSchema,
    lines: z.array(
      LineSchema.extend({
        orderLineNumber: z.string().nullable(),
        lineNo: z.number().nullable(),
        taken: z.boolean(),
      }),
    ),
  }),
  differingFields: z.array(FieldsSchema.keyof()),
  suggestedPairs: z.array(PairSchema),
  replaceBlockedLineIds: z.array(z.string()),
  gaps: z.object({ merge: z.array(GapSchema), replace: z.array(GapSchema) }),
});
export type TracingLinkPreviewResponse = z.infer<
  typeof TracingLinkPreviewSchema
>;
